interface MLAppConfigType {
    GET_ML_RAW_MATERIAL_SUMMARY: string;
    GET_MATERIAL_LEDGER: string;
    GET_ML_INVENTORY_UPDATES: string;
    CREATE_INVENTORY_DASHBOARD: string;
    GET_SAS_URL: string;
    PROCESS_EXCEL_DATA: string;
    DOWNLOAD_EXCEL_TEMPLATE: string;
}

const ML_TYPES: any = {
    ML: "v1/ml",
}

export const MLAppConfig: MLAppConfigType = {
    GET_ML_RAW_MATERIAL_SUMMARY: `${ML_TYPES.ML}/get-ml-shipment-consignee-details`,
    GET_MATERIAL_LEDGER: `${ML_TYPES.ML}/get-material-ledger`,
    GET_ML_INVENTORY_UPDATES: `${ML_TYPES.ML}/get-material-ledger`,
    CREATE_INVENTORY_DASHBOARD: `${ML_TYPES.ML}/post-inventory-updates`,
    GET_SAS_URL: `${ML_TYPES.ML}/get-sas-url`,
    PROCESS_EXCEL_DATA: `${ML_TYPES.ML}/post-excel-data`,
    DOWNLOAD_EXCEL_TEMPLATE: `${ML_TYPES.ML}/download-excel-template`
}
